import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AdminHeader from "../../common/AdminHeader";
import { Modal, Button, Form } from "react-bootstrap";
import Footer from "../../common/Footer";
import { baseUrl, formatDateToDDMMYYYY } from "../../../Utility/constants";

const SessionMaster = () => {
  const [sessions, setSessions] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [currentSession, setCurrentSession] = useState({
    sessionId: 0,
    sessionName: "",
    startDate: "",
    endDate: "",
    createdBy: localStorage.getItem("userID"),
    createdDate: new Date().toISOString(),
    updatedBy: localStorage.getItem("userID"),
    updatedDate: new Date().toISOString(),
    isActive: 1,
    isCurrentSession: 0,
  });

  const apiUrl = `${baseUrl}/api/SessionMaster`;

  useEffect(() => {
    fetchSessions();
  }, []);

  const fetchSessions = async () => {
    try {
      const response = await axios.get(apiUrl);
      setSessions(response.data);
    } catch (error) {
      toast.error("Failed to fetch sessions");
    }
  };

  const handleAdd = () => {
    setCurrentSession({
      sessionId: 0,
      sessionName: "",
      startDate: "",
      endDate: "",
      createdBy: localStorage.getItem("userID"),
      createdDate: new Date().toISOString(),
      updatedBy: localStorage.getItem("userID"),
      updatedDate: new Date().toISOString(),
      isActive: 1,
      isCurrentSession: 0,
    });
    setIsEditing(false);
    setShowModal(true);
  };

  const handleEdit = (session) => {
    setCurrentSession({
      ...session,
      updatedBy: localStorage.getItem("userID"),
      updatedDate: new Date().toISOString(),
    });
    setIsEditing(true);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this session?")) {
      try {
        await axios.delete(`${apiUrl}/${id}`);
        toast.success("Session deleted successfully");
        fetchSessions();
      } catch (error) {
        toast.error("Failed to delete session");
      }
    }
  };

  const handleSave = async () => {
    try {
      if (isEditing) {
        await axios.put(`${apiUrl}/${currentSession.sessionId}`, currentSession);
        toast.success("Session updated successfully");
      } else {
        await axios.post(apiUrl, currentSession);
        toast.success("Session added successfully");
      }
      fetchSessions();
      setShowModal(false);
    } catch (error) {
      toast.error("Failed to save session");
    }
  };

  return (
    <>
      <AdminHeader />
      <div className="container mt-5">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2>Manage Sessions</h2>
          <Button variant="primary" onClick={handleAdd}>
            Add New Session
          </Button>
        </div>
        <table className="table table-bordered table-striped">
          <thead className="thead-dark">
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Current Session</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {sessions.map((session, index) => (
              <tr key={session.sessionId}>
                <td>{index + 1}</td>
                <td>{session.sessionName}</td>
                <td>{formatDateToDDMMYYYY(session.startDate)}</td>
                <td>{formatDateToDDMMYYYY(session.endDate)}</td>
                <td>{session.isCurrentSession === 1 ? "Yes" : "No"}</td>
                <td>
                  <Button
                    variant="warning"
                    onClick={() => handleEdit(session)}
                  >
                    Edit
                  </Button>{" "}
                  <Button
                    variant="danger"
                    onClick={() => handleDelete(session.sessionId)}
                  >
                    Delete
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Add/Edit Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {isEditing ? "Edit Session" : "Add Session"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="sessionName">
              <Form.Label>Session Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter session name"
                value={currentSession.sessionName}
                onChange={(e) =>
                  setCurrentSession({
                    ...currentSession,
                    sessionName: e.target.value,
                  })
                }
              />
            </Form.Group>

            <Form.Group controlId="startDate">
              <Form.Label>Start Date</Form.Label>
              <Form.Control
                type="date"
                value={currentSession.startDate.split("T")[0]}
                onChange={(e) =>
                  setCurrentSession({
                    ...currentSession,
                    startDate: e.target.value,
                  })
                }
              />
            </Form.Group>

            <Form.Group controlId="endDate">
              <Form.Label>End Date</Form.Label>
              <Form.Control
                type="date"
                value={currentSession.endDate.split("T")[0]}
                onChange={(e) =>
                  setCurrentSession({
                    ...currentSession,
                    endDate: e.target.value,
                  })
                }
              />
            </Form.Group>

            <Form.Group controlId="isCurrentSession">
              <Form.Check
                type="checkbox"
                label="Is Current Session"
                checked={currentSession.isCurrentSession === 1}
                onChange={(e) =>
                  setCurrentSession({
                    ...currentSession,
                    isCurrentSession: e.target.checked ? 1 : 0,
                  })
                }
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleSave}>
            {!isEditing ? "Add" : "Update"}
          </Button>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      <ToastContainer />
      <Footer />
    </>
  );
};

export default SessionMaster;
